import { Component, OnInit } from '@angular/core';
import { DoctorService } from '../../services/doctor.service';
import { FormBuilder, Validators, FormGroup, ValidatorFn, AbstractControl, FormControl } from '@angular/forms';
import { CommonService } from '../../services/common.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material';
import { TagalertComponent } from '../tagalert/tagalert.component';
import { SendnotificationComponent } from '../sendnotification/sendnotification.component';
@Component({
  selector: 'app-managepatient',
  templateUrl: './managepatient.component.html',
  styleUrls: ['./managepatient.component.css']
})
export class ManagepatientComponent implements OnInit {
  uid: any;
  showadddiv = false;
  shownormaldiv = true;
  registerform: any;
  password: number;
  email: string;
  ruser = [];
  myruserarray = [];
  ipadd: any;
  public loading = false;
  constructor(public form: FormBuilder, private doctorservice:  DoctorService,
    private commonService: CommonService, private router: Router, private dialog: MatDialog,) {
    this.registerform = this.form.group({
      'email': new FormControl('', [Validators.required,
      Validators.pattern(/^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i)]),
      'name': new FormControl('', [Validators.required]),
      'mobile': new FormControl('', [Validators.required, Validators.minLength(10)]),
    });
    const udata = this.commonService.getUserDataLocally();
    this.uid = udata.uid;
   }

  ngOnInit() {
    this.loading = true;
    this.getAllMyRegisterpatient();
    this.commonService.getIpAddress()
    .subscribe(
      (x) => {
        this.ipadd = x.ip;
      });
  }
  onRegister() {
    this.loading = true;
    this.password  = this.getRandomInt();
    const bio = 'about me';
    const gender = 'mf';
    const role_id = 2;
    const dob = '00/00/0000';
    const remember_token = '1';
     const image = 'avatar-1577909_960_720.png';
     const source = 'Doctor';
     this.doctorservice.createUser(this.registerform.name, this.registerform.email, this.registerform.mobile,
      bio, image, gender, role_id, dob, remember_token, this.password, this.ipadd, source,)
    .subscribe(result => {
     if (result === true) {
       this.getCreateduserId();
     }
    },(error)=>{
      this.loading = false;
      this.openAlert();
    });
  }
  getCreateduserId() {
    this.doctorservice.getMyData(this.registerform.email)
    .subscribe(
      (x) => {
        const guid = x[0].id;
        this.createRegisteruser(guid);
      }
    );
  }
  createRegisteruser(guid) {
    this.doctorservice.registerPatientWithUs(this.uid, guid)
    .subscribe(
      (x) => {
        this.getAllMyRegisterpatient();
        this.AddExistingUser();
      }
    );
  }
  getRandomInt() {
    return Math.floor(Math.random() * (20000 - 5 + 1)) + 5;
  }
  getAllMyRegisterpatient() {
    this.myruserarray = [];
    this.doctorservice.getAllMyRegisterPatient(this.uid)
    .subscribe(
      (x) => {
        this.loading = false;
        this.ruser = x;
        if (this.ruser.length > 0) {
          for ( let i = 0; i < this.ruser.length; i ++) {
            this.getMyRegisterUserDetail(this.ruser[i].register_user_id);
          }
        }
      }
    );
   }
   viewProfile(id) {
     this.router.navigate(['/doctor/registeredpatient/' + id]);
   }
   getMyRegisterUserDetail(user_id) {
    this.doctorservice.getAppointmentmentUserDetail(user_id)
    .subscribe(
      (x) => {
        this.myruserarray.push(x[0]);
      }
    );
   }
   AddExistingUser()  {
     this.shownormaldiv = !this.shownormaldiv;
     this.showadddiv = !this.showadddiv;
   }
   sendNotification(id) {
    const dialogRef = this.dialog.open(SendnotificationComponent, {
      width: '500px',
      height: '400px',
      data: {userid: id}
    });
    
  }
  openAlert(){
    const dialogRef = this.dialog.open(TagalertComponent, {
      width: '400px',
      height: '300px',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 1) {
        this.loading = true;
      this.serchUserByEmail();
      }
    });
  }
  serchUserByEmail(){
    this.doctorservice.getMyData(this.registerform.email)
    .subscribe(
      (x) => {
        if(x.length>0){
          const guid = x[0].id;
          this.checkAlreadyTagged(guid);
        }else {
          this.searchUserByMobile()
        }
      });
  }
  searchUserByMobile() {
    this.doctorservice.getdataByMobile(this.registerform.mobile)
    .subscribe(
      (x) =>{
        const guid = x[0].id;
        this.checkAlreadyTagged(guid);
      });
  }
  checkAlreadyTagged(guid) {
    this.doctorservice.checkAlreadyTagged(guid, this.uid)
    .subscribe(
      (x) => {
        if(x.length>0) {
          this.loading = false;
          alert('this Customer is already registered with you');
          this.AddExistingUser();
        }else{
          this.createRegisteruser(guid);
        }
      });
  }
}
